import { render, staticRenderFns } from "./gr.vue?vue&type=template&id=29c2acb5&scoped=true"
import script from "./gr.vue?vue&type=script&lang=js"
export * from "./gr.vue?vue&type=script&lang=js"
import style0 from "./gr.vue?vue&type=style&index=0&id=29c2acb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2acb5",
  null
  
)

export default component.exports